import {
    Column,
    Entity,
    Index,
    JoinColumn, JoinTable, ManyToMany,
    OneToMany,
    OneToOne,
    PrimaryGeneratedColumn,
} from "typeorm";
import { PlatformUser } from "./PlatformUser";
import { BetaReaderProject } from "./BetaReaderProject";
import {ProjectProfileGroup} from "./ProjectProfileGroup";
import {SCHEMA_CODE} from "../../project_schemas";

@Index("beta_reader_profile_pkey", ["id"], { unique: true })
@Index("beta_reader_profile_unique_idx", ["platformUserId"], { unique: true })
@Entity("beta_reader_profile")
export class BetaReaderProfile {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: number;

  @Column("bigint", { name: "platform_user_id" })
  platformUserId!: number;

  @Column("text", { name: "bio_sketch", nullable: true })
  bioSketch: string | null;

  @OneToOne(
    (type) => PlatformUser,
    (platformUser) => platformUser.betaReaderProfile
  )
  @JoinColumn([{ name: "platform_user_id", referencedColumnName: "id" }])
  platformUser!: PlatformUser;

  @ManyToMany(
    () => ProjectProfileGroup, { eager: true }
  )
  @JoinTable({
      name: "beta_reader_profile_profile_group",
      joinColumn: {
          name: "beta_reader_profile_id",
          referencedColumnName: "id"
      },
      inverseJoinColumn: {
          name: "profile_group_id",
          referencedColumnName: "id"
      }
  })
  profileGroups!: ProjectProfileGroup[];

  @OneToMany(
    (type) => BetaReaderProject,
    (betaReaderProject) => betaReaderProject.betaReaderProfile
  )
  betaReaderProjects!: BetaReaderProject[];

    getProfileGroupForCode(code: string) {
        if (!code) { return null; }
        if (!this.profileGroups) {
            this.profileGroups = [];
        }
        let group: ProjectProfileGroup | undefined = this.profileGroups.find(pg => pg.projectSchemaCode === code);
        if (!group) {
            group = new ProjectProfileGroup();
            group.projectSchemaCode = code;
            group.profileSelections = [];
            this.profileGroups.push(group);
            console.log("I assigned a new project group from the entity object!!!!!!!");
        }
        return group;
    }
}
